import { updateObject } from './../../utils/utility';
import { hazardousItemsExistIn } from './../../libs/data-transform';

const initialState = {
    categories: [],
    hasHazardousCategories: false,
    shippingMaterials: [],
    suggestedMaterials: [],
    materialsListRefreshed: false,
    scheduleSlots: [],
    supportEmail: "hpcustomerservice@ctlus.com",
    contactSupportDetails: {},
    countryMappingDetails: []
};

const setContactSupportDetails = (state = initialState, action) => {
    const data = action.payload.data;
    return updateObject(state, { contactSupportDetails: data }
    );
}

const setCategoriesData = (state = initialState, action) => {
    const data = action.payload.data;
    return updateObject(state,
        {
            categories: data.categoryList,
            hasHazardousCategories: hazardousItemsExistIn(data.categoryList)
        }
    );
}

const resetCategoriesData = (state = initialState, action) => {
    return updateObject(state, { categories: [] }
    );
}

const setShippingMaterials = (state = initialState, action) => {
    const data = action.payload.data;
    const suggestedMaterials = data.suggestedMaterials || [];
    return updateObject(state, {
        shippingMaterials: data.shippingMaterialList,
        suggestedMaterials: suggestedMaterials,
        materialsListRefreshed: true
    }
    );
}

const reSetShippingMaterials = (state = initialState, action) => {
    return updateObject(state, { shippingMaterials: [] });
}

const setMaterialsListRefreshed = (state = initialState) => {
    return updateObject(state, { materialsListRefreshed: false });
}

const setScheduleSlots = (state = initialState, action) => {
    const data = action.payload.data;
    return updateObject(state, { scheduleSlots: data }
    );
}

const resetCatalog = (state = initialState) => {
    return updateObject(state, initialState);
}

const setPreAuthenticationCatalogData = (state = initialState, action) => {
    return updateObject(state, action.data);
}

const getCountryMappingDetails = (state = initialState, action) => {
    return updateObject(state, action.data);
}

const reducer = (state = initialState, action) => {

    if (action.type === "SET_CONTACT_SUPPORT_DATA") {
        return setContactSupportDetails(state, action);
    }
    if (action.type === "SET_CATEGORIES_DATA") {
        return setCategoriesData(state, action);
    }
    if (action.type === "RESET_CATEGORIES_DATA") {
        return resetCategoriesData(state, action);
    }
    if (action.type === "SET_MATERIALS_DATA") {
        return setShippingMaterials(state, action);
    }
    if (action.type === "SET_SCHEDULE_SLOTS") {
        return setScheduleSlots(state, action);
    }
    if (action.type === "SET_MATERIALS_LIST_REFRESHED") {
        return setMaterialsListRefreshed(state);
    }
    if (action.type === "RESET_SHIPPING_MATERIAL") {
        return reSetShippingMaterials(state, action)
    }
    if (action.type === "SET_PRE_AUTHENTICATION_CATALOG_DATA") {
        return setPreAuthenticationCatalogData(state, action);
    }
    if (action.type === "SET_COUNTRY_MAPPING_DETAILS") {
        return getCountryMappingDetails(state, action);
    }
    if (action.type === "RESET_CATALOG") {
        return resetCatalog(state);
    }
    return state;
}

export default reducer;